import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import {
  LocationOn,
} from "@mui/icons-material";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import hero from "../../Assets/hero.png";
import SubProduct from "../../Assets/SubProduct.png";
import herobg from "../../Assets/herobg.png";
import arrow from "../../Assets/arrow.png";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import PopUp from "../Pop-up/pop-up";
import config from "../../Config";
import { setCookie, getCookie, } from "../../HelperFunction/cookies";

const LandingPage = () => {
  const [weddingCollections, setWeddingCollections] = useState([]);
  const [banners, setBanners] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);
  const [sponsorProducts, setSponsorProducts] = useState([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const navigate = useNavigate();

  //Login Popup
  useEffect(() => {
    const token = sessionStorage.getItem("newToken");
    const shown = getCookie("loginPopupShown");

    if (!token && !shown) {
      setShowLoginPopup(true);
      setCookie(
        "loginPopupShown",
        "true",
        4
      );
    }
  }, []);

  // WebHomeAPi
  useEffect(() => {
    const fetchCollections = async () => {
      try {
        const response = await axios.get(`${config.apiBaseUrl}/${config.webHomeCollections}`);

        if (!response?.data?.success) {
          return;
        }

        const data = response.data;

        const webBanners = Array.isArray(data.banners)
          ? data.banners.filter(
            (banner) =>
              banner?.isVisible !== false && (banner?.bannerType === "web" || !banner?.bannerType)
          )
          : [];

        setBanners(webBanners);

        const collections = Array.isArray(data.collections)
          ? data.collections
          : [];

        const formattedCollections =
          collections.map((collection) => ({
            ...collection,
            topProducts: Array.isArray(collection.productList)
              ? collection.productList
                .filter(Boolean)
                .slice(0, 3)
                .map((product) => ({
                  ...product,
                  city: product?.address?.city || "",
                  availableDate: product?.slots?.availableDate || "",
                }))
              : [],
          }));

        setWeddingCollections(formattedCollections);

        const arrivals = Array.isArray(data.newArrivals)
          ? data.newArrivals
            .filter(Boolean)
            .slice(0, 8)
            .map((item) => {
              const productData =
                item?.product || {};

              return {
                ...item,
                city: item?.address?.city || "",
                availableDate: item?.slots?.availableDate || "",
                product: {
                  ...productData,
                  productImage: Array.isArray(item?.productImage) &&
                    item.productImage.length > 0
                    ? item.productImage
                    : Array.isArray(productData?.productImage)
                      ? productData.productImage
                      : [],
                },
              };
            })
          : [];

        setNewArrivals(arrivals);

        // SPONSORED PRODUCTS
        // Show ALL active sponsored products based on priority
        const sponsors = Array.isArray(data.sponsorProducts)
          ? data.sponsorProducts
            .map((item) => ({
              ...item,
              priority: Number(item?.priority || 0),
              product: item?.product || {},
            }))
            .filter(
              (item) =>
                item?.product?.product?.productId &&
                item?.product?.productStatus === true
            )
            .sort((a, b) => {
              if (b.priority !== a.priority) {
                return b.priority - a.priority;
              }

              return (
                new Date(b?.product?.createdAt || 0) -
                new Date(a?.product?.createdAt || 0)
              );
            })
          : [];

        setSponsorProducts(sponsors);

      } catch (error) {
        console.error("Error fetching homepage data:", error?.response?.data || error);
      }
    };

    fetchCollections();
  }, []);

  const handleProductClick = (productId) => {
    if (!productId) return;
    navigate(`/ProductDetail/${productId}`);
  };


  const handleCollectionClick = (collectionId) => {
    if (!collectionId) return;
    navigate(`/explore/collection/${encodeURIComponent(collectionId)}`);
  };


  const handleExploreClick = (type, value = "") => {
    if (!type) return;

    if (value) {
      navigate(`/explore/${type}/${encodeURIComponent(value)}`);
    } else {
      navigate(`/explore/${type}`);
    }
  };

  //Login Popup
  const handleLoginPopupPrimary = () => {
    navigate("/Signin");
  };


  return (
    <Box
      sx={{ backgroundColor: "#fff", color: "#171717", overflow: "hidden", }}
    >
      <Helmet>
        <title>
          Hindusthan Wardrobe | Rent Fashion, Wear Luxury
        </title>

        <meta
          name="description"
          content="Rent premium fashion, wear luxury outfits, and return with ease. Discover designer clothing and accessories through convenient and sustainable fashion rental."
        />

        <meta
          name="keywords"
          content="fashion rental, clothes rental, designer clothes rental, wedding dress rental, luxury fashion rental, Hindusthan Wardrobe"
        />

        <meta
          property="og:title"
          content="Hindusthan Wardrobe | Rent Fashion, Wear Luxury"
        />

        <meta
          property="og:description"
          content="Rent premium fashion and luxury outfits without the commitment of buying."
        />
      </Helmet>

      <Navbar />

      {/* =====================================================
          HERO
      ===================================================== */}

      <Box
        sx={{
          position: "relative",
          minHeight: {
            xs: "auto",
            md: 620,
          },
          display: "flex",
          alignItems: "center",
          backgroundImage: `url(${herobg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(90deg, rgba(0,0,0,0.48) 0%, rgba(0,0,0,0.18) 55%, rgba(0,0,0,0.05) 100%)",
          }}
        />

        <Container
          maxWidth="lg"
          sx={{
            position: "relative",
            zIndex: 2,
            py: {
              xs: 7,
              md: 8,
            },
          }}
        >
          <Grid
            container
            spacing={{
              xs: 5,
              md: 3,
            }}
            alignItems="center"
          >
            {/* HERO CONTENT */}

            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  maxWidth: 580,
                  color: "#fff",
                }}
              >
                <Typography
                  sx={{
                    fontSize: {
                      xs: "0.72rem",
                      md: "0.82rem",
                    },
                    letterSpacing: {
                      xs: 2,
                      md: 4,
                    },
                    fontWeight: 600,
                    mb: 2,
                    textTransform: "uppercase",
                  }}
                >
                  Rent. Wear. Return. It's that simple.
                </Typography>

                <Typography
                  component="h1"
                  sx={{
                    fontSize: {
                      xs: "2.7rem",
                      sm: "3.5rem",
                      md: "4.6rem",
                    },
                    lineHeight: 0.98,
                    fontWeight: 700,
                    letterSpacing: "-0.04em",
                    mb: 3,
                  }}
                >
                  Dress Like It's,
                  <br />

                  <Box
                    component="span"
                    sx={{
                      fontWeight: 300,
                    }}
                  >
                     Your Moment.
                  </Box>
                </Typography>

                <Typography
                  sx={{
                    maxWidth: 490,
                    fontSize: {
                      xs: "0.95rem",
                      md: "1.05rem",
                    },
                    lineHeight: 1.8,
                    color:
                      "rgba(255,255,255,0.84)",
                    mb: 4,
                  }}
                >
                  Designer looks for weddings, celebrations and milestones, at a fraction of the price. Delivered fresh across India.
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1.5,
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() => {
                      const section =
                        document.getElementById(
                          "new-arrivals"
                        );

                      section?.scrollIntoView({
                        behavior: "smooth",
                      });
                    }}
                    sx={{
                      px: 3.5,
                      py: 1.4,
                      borderRadius: 0,
                      backgroundColor: "#fff",
                      color: "#111",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      "&:hover": {
                        backgroundColor: "#f2f2f2",
                      },
                    }}
                  >
                    Explore Collection
                  </Button>

                  <Button
                    variant="outlined"
                    onClick={() => {
                      const section =
                        document.getElementById(
                          "wedding-collections"
                        );

                      section?.scrollIntoView({
                        behavior: "smooth",
                      });
                    }}
                    sx={{
                      px: 3.5,
                      py: 1.4,
                      borderRadius: 0,
                      borderColor:
                        "rgba(255,255,255,0.7)",
                      color: "#fff",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      "&:hover": {
                        borderColor: "#fff",
                        backgroundColor:
                          "rgba(255,255,255,0.08)",
                      },
                    }}
                  >
                    Wedding Edit
                  </Button>
                </Box>
              </Box>
            </Grid>

            {/* HERO IMAGES */}

            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  position: "relative",
                  minHeight: {
                    xs: 300,
                    sm: 380,
                    md: 470,
                  },
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    right: {
                      xs: "18%",
                      md: "20%",
                    },
                    top: {
                      xs: 0,
                      md: 10,
                    },
                    width: {
                      xs: "62%",
                      sm: "52%",
                      md: "55%",
                    },
                    height: {
                      xs: 300,
                      sm: 370,
                      md: 450,
                    },
                    zIndex: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={hero}
                    alt="Premium fashion collection"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    position: "absolute",
                    right: 0,
                    bottom: {
                      xs: 0,
                      md: 20,
                    },
                    width: {
                      xs: "48%",
                      md: "42%",
                    },
                    height: {
                      xs: 170,
                      md: 250,
                    },
                    zIndex: 3,
                  }}
                >
                  <Box
                    component="img"
                    src={arrow}
                    alt="Explore fashion"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    bottom: 0,
                    width: {
                      xs: "58%",
                      md: "52%",
                    },
                    height: {
                      xs: 90,
                      md: 120,
                    },
                    zIndex: 4,
                    overflow: "hidden",
                  }}
                >
                  <Box
                    component="img"
                    src={SubProduct}
                    alt="Fashion collection details"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* =====================================================
          BRAND MESSAGE
      ===================================================== */}

      <Container
        maxWidth="md"
        sx={{
          py: {
            xs: 7,
            md: 10,
          },
          textAlign: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "0.75rem",
            letterSpacing: 3,
            textTransform: "uppercase",
            color: "text.secondary",
            mb: 2,
          }}
        >
          The Hindusthan Wardrobe Edit
        </Typography>

        <Typography
          component="h2"
          sx={{
            fontSize: {
              xs: "2rem",
              md: "3rem",
            },
            fontWeight: 500,
            lineHeight: 1.2,
            mb: 2,
          }}
        >
          Your wardrobe should change
          <br />

          <Box
            component="span"
            sx={{
              fontStyle: "italic",
            }}
          >
            with your moments.
          </Box>
        </Typography>

        <Typography
          sx={{
            color: "text.secondary",
            lineHeight: 1.8,
            maxWidth: 650,
            mx: "auto",
          }}
        >
          From weddings and celebrations to
          statement evenings, discover premium
          styles made for the moment — then
          return them for your next story.
        </Typography>
      </Container>

      {/* =====================================================
          SPONSOR PRODUCTS
      ===================================================== */}

      {sponsorProducts.length > 0 && (
        <Box
          sx={{
            backgroundColor: "#f7f5f1",
            py: {
              xs: 7,
              md: 10,
            },
          }}
        >
          <Container maxWidth="lg">
            <Box
              sx={{
                display: "flex",
                alignItems: {
                  xs: "flex-start",
                  md: "flex-end",
                },
                justifyContent: "space-between",
                mb: 5,
                gap: 2,
              }}
            >
              <Box>
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    letterSpacing: 3,
                    textTransform: "uppercase",
                    color: "text.secondary",
                    mb: 1,
                  }}
                >
                  Curated for you
                </Typography>

                <Typography
                  component="h2"
                  sx={{
                    fontSize: {
                      xs: "2rem",
                      md: "2.8rem",
                    },
                    fontWeight: 600,
                  }}
                >
                  Rent Fashion, Wear Luxury
                </Typography>
              </Box>

              <Button
                onClick={() =>
                  handleExploreClick("sponsor")
                }
                sx={{
                  display: {
                    xs: "none",
                    sm: "inline-flex",
                  },
                  color: "#111",
                  textTransform: "uppercase",
                  letterSpacing: 1,
                }}
              >
                Discover More →
              </Button>
            </Box>

            {/* SPONSOR PRODUCTS */}

            <Grid
              container
              spacing={2}
            >
              {sponsorProducts.map(
                (item) => {
                  const product =
                    item?.product || {};

                  const productData =
                    product?.product || {};

                  const productId =
                    productData?.productId;

                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={2.4}
                      key={
                        product?._id ||
                        productId
                      }
                    >
                      <Card
                        elevation={0}
                        onClick={() =>
                          handleProductClick(
                            productId
                          )
                        }
                        sx={{
                          height: "100%",
                          backgroundColor:
                            "transparent",
                          cursor: "pointer",
                          transition:
                            "transform 0.35s ease",
                          "&:hover": {
                            transform:
                              "translateY(-6px)",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            position:
                              "relative",
                            overflow:
                              "hidden",
                            borderRadius: 1,
                            backgroundColor:
                              "#ece9e4",
                          }}
                        >
                          <CardMedia
                            component="img"
                            height="320"
                            image={
                              product
                                ?.productImage?.[0] ||
                              ""
                            }
                            alt={
                              productData?.title ||
                              "Fashion product"
                            }
                            sx={{
                              objectFit:
                                "cover",
                              transition:
                                "transform 0.5s ease",
                              "&:hover": {
                                transform:
                                  "scale(1.035)",
                              },
                            }}
                          />
                        </Box>

                        <CardContent
                          sx={{
                            px: 0.5,
                            py: 1.5,
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: 600,
                              mb: 0.5,
                            }}
                          >
                            {productData?.title ||
                              "Fashion Product"}
                          </Typography>

                          <Typography
                            variant="body2"
                            color="text.secondary"
                          >
                            ₹
                            {productData?.rentAmount ||
                              0}
                            /Day
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                }
              )}
            </Grid>

            {/* MOBILE DISCOVER BUTTON */}

            <Box
              sx={{
                display: {
                  xs: "flex",
                  sm: "none",
                },
                justifyContent:
                  "center",
                mt: 4,
              }}
            >
              <Button
                onClick={() =>
                  handleExploreClick(
                    "sponsor"
                  )
                }
                sx={{
                  color: "#111",
                  borderBottom:
                    "1px solid #222",
                  borderRadius: 0,
                  textTransform:
                    "uppercase",
                  letterSpacing: 1,
                  fontSize:
                    "0.72rem",
                }}
              >
                Discover More →
              </Button>
            </Box>
          </Container>
        </Box>
      )}

      {/* =====================================================
          COLLECTIONS
      ===================================================== */}

      <Box
        id="wedding-collections"
        sx={{
          py: {
            xs: 7,
            md: 11,
          },
        }}
      >
        <Container maxWidth="lg">
          {weddingCollections.map(
            (
              collection,
              collectionIndex
            ) => (
              <React.Fragment
                key={
                  collection.collectionId
                }
              >
                {/* COLLECTION TITLE */}

                <Box
                  sx={{
                    textAlign: "center",
                    mb: 6,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize:
                        "0.72rem",
                      letterSpacing: 3,
                      textTransform:
                        "uppercase",
                      color:
                        "text.secondary",
                      mb: 1,
                    }}
                  >
                    Featured Collection
                  </Typography>

                  <Typography
                    component="h2"
                    sx={{
                      fontSize: {
                        xs: "2.1rem",
                        md: "3rem",
                      },
                      fontWeight: 600,
                    }}
                  >
                    {
                      collection.collectionTitle
                    }
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent:
                        "center",
                      mt: 2,
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() =>
                        handleCollectionClick(
                          collection.collectionId
                        )
                      }
                      sx={{
                        borderColor:
                          "#222",
                        color:
                          "#222",
                        borderRadius: 0,
                        px: 3,
                        py: 1.1,
                        textTransform:
                          "uppercase",
                        letterSpacing: 1,
                        fontSize:
                          "0.72rem",
                        fontWeight: 600,
                        "&:hover": {
                          borderColor:
                            "#222",
                          backgroundColor:
                            "#222",
                          color:
                            "#fff",
                        },
                      }}
                    >
                      View All Products
                    </Button>
                  </Box>
                </Box>

                {/* COLLECTION PRODUCTS */}

                <Grid
                  container
                  spacing={3}
                >
                  {collection.topProducts.map(
                    (product) => {
                      const productData =
                        product?.product ||
                        product;

                      const productId =
                        productData?.productId;

                      const productImage =
                        Array.isArray(
                          product?.productImage
                        ) &&
                          product.productImage.length > 0
                          ? product.productImage[0]
                          : "";

                      return (
                        <Grid
                          item
                          xs={12}
                          md={4}
                          key={
                            product?._id ||
                            productId
                          }
                        >
                          <Card
                            elevation={0}
                            sx={{
                              height:
                                "100%",
                              border:
                                "1px solid #e7e4df",
                              borderRadius: 2,
                              overflow:
                                "hidden",
                              display:
                                "flex",
                              flexDirection: {
                                xs: "column",
                                sm: "row",
                                md: "column",
                              },
                              backgroundColor:
                                "#fff",
                            }}
                          >
                            <Box
                              sx={{
                                width: {
                                  xs: "100%",
                                  sm: "50%",
                                  md: "100%",
                                },
                                height: {
                                  xs: 340,
                                  sm: 300,
                                  md: 380,
                                },
                                overflow: "hidden",
                                cursor: "pointer",
                                backgroundColor: "#f8f8f8",
                              }}
                              onClick={() =>
                                handleProductClick(
                                  productId
                                )
                              }
                            >
                              <CardMedia
                                component="img"
                                image={
                                  product?.productImage?.[0] ||
                                  ""
                                }
                                alt={
                                  productData?.title ||
                                  "Fashion product"
                                }
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  objectPosition: "center",
                                  display: "block",
                                }}
                              />
                            </Box>

                            <CardContent
                              sx={{
                                flex: 1,
                                width: {
                                  xs: "100%",
                                  sm: "50%",
                                  md: "100%",
                                },
                                p: {
                                  xs: 2.5,
                                  md: 3,
                                },
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Typography
                                variant="h6"
                                sx={{
                                  fontWeight:
                                    600,
                                  mb: 1,
                                }}
                              >
                                {
                                  productData?.title
                                }
                              </Typography>

                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                  lineHeight:
                                    1.7,
                                  mb: 2,
                                  display:
                                    "-webkit-box",
                                  WebkitLineClamp: 3,
                                  WebkitBoxOrient:
                                    "vertical",
                                  overflow:
                                    "hidden",
                                }}
                              >
                                {
                                  productData?.description
                                }
                              </Typography>

                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                  mb: 0.8,
                                }}
                              >
                                Available:{" "}
                                {product
                                  ?.availableDate ||
                                  product
                                    ?.slots
                                    ?.availableDate ||
                                  "Available soon"}
                              </Typography>

                              <Typography
                                sx={{
                                  fontWeight:
                                    700,
                                  fontSize:
                                    "1.05rem",
                                  mb: 1.5,
                                }}
                              >
                                ₹
                                {
                                  productData?.rentAmount
                                }
                                /Day
                              </Typography>

                              {product?.city && (
                                <Box
                                  sx={{
                                    display:
                                      "flex",
                                    alignItems:
                                      "center",
                                    gap: 0.5,
                                    mb: 2,
                                  }}
                                >
                                  <LocationOn
                                    sx={{
                                      fontSize:
                                        18,
                                      color:
                                        "text.secondary",
                                    }}
                                  />

                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    {
                                      product.city
                                    }
                                  </Typography>
                                </Box>
                              )}

                              <Button
                                variant="outlined"
                                onClick={() =>
                                  handleProductClick(
                                    productId
                                  )
                                }
                                sx={{
                                  mt: "auto",
                                  alignSelf:
                                    "flex-start",
                                  borderColor:
                                    "#222",
                                  color:
                                    "#222",
                                  borderRadius:
                                    0,
                                  px: 2.5,
                                  textTransform:
                                    "uppercase",
                                  letterSpacing:
                                    1,
                                  fontSize:
                                    "0.72rem",
                                  "&:hover": {
                                    borderColor:
                                      "#222",
                                    backgroundColor:
                                      "#222",
                                    color:
                                      "#fff",
                                  },
                                }}
                              >
                                View Details
                              </Button>
                            </CardContent>
                          </Card>
                        </Grid>
                      );
                    }
                  )}
                </Grid>

                {/* COLLECTION BANNER */}

                {banners[
                  collectionIndex
                ] && (
                    <Box
                      sx={{
                        mt: {
                          xs: 7,
                          md: 10,
                        },
                        mb: {
                          xs: 2,
                          md: 4,
                        },
                        width: "100%",
                        overflow:
                          "hidden",
                      }}
                    >
                      <Box
                        component="img"
                        src={
                          banners[
                            collectionIndex
                          ]?.bannerIcon ||
                          ""
                        }
                        alt={
                          banners[
                            collectionIndex
                          ]?.bannerName ||
                          "Hindusthan Wardrobe banner"
                        }
                        sx={{
                          width:
                            "100%",
                          height: {
                            xs: 180,
                            sm: 260,
                            md: 380,
                          },
                          display:
                            "block",
                          objectFit:
                            "cover",
                        }}
                      />
                    </Box>
                  )}
              </React.Fragment>
            )
          )}
        </Container>
      </Box>

      {/* =====================================================
          NEW ARRIVALS
      ===================================================== */}

      <Box
        id="new-arrivals"
        sx={{
          backgroundColor: "#f7f5f1",
          py: {
            xs: 7,
            md: 10,
          },
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              mb: 5,
              textAlign: {
                xs: "left",
                md: "center",
              },
            }}
          >
            <Typography
              sx={{
                fontSize: "0.72rem",
                letterSpacing: 3,
                textTransform:
                  "uppercase",
                color: "text.secondary",
                mb: 1,
              }}
            >
              Fresh arrivals
            </Typography>

            <Typography
              component="h2"
              sx={{
                fontSize: {
                  xs: "2.2rem",
                  md: "3rem",
                },
                fontWeight: 600,
              }}
            >
              New Arrivals
            </Typography>

            <Button
              onClick={() =>
                handleExploreClick(
                  "new-arrival"
                )
              }
              sx={{
                mt: 2,
                color: "#111",
                borderBottom:
                  "1px solid #222",
                borderRadius: 0,
                textTransform:
                  "uppercase",
                letterSpacing: 1,
                fontSize:
                  "0.72rem",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor:
                    "transparent",
                  borderBottomColor:
                    "#777",
                },
              }}
            >
              View All New Arrivals →
            </Button>
          </Box>

          <Grid
            container
            spacing={2}
          >
            {newArrivals.map((item) => {
              const product =
                item?.product || {};

              const productId =
                product?.productId;

              return (
                <Grid
                  item
                  key={
                    item?._id ||
                    productId
                  }
                  xs={12}
                  sm={6}
                  md={3}
                >
                  <Card
                    elevation={0}
                    onClick={() =>
                      handleProductClick(
                        productId
                      )
                    }
                    sx={{
                      height: "100%",
                      cursor:
                        "pointer",
                      backgroundColor:
                        "transparent",
                      transition:
                        "transform 0.35s ease",
                      "&:hover": {
                        transform:
                          "translateY(-5px)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        overflow:
                          "hidden",
                        backgroundColor:
                          "#ece9e4",
                        borderRadius: 1,
                      }}
                    >
                      <CardMedia
                        component="img"
                        height="380"
                        image={
                          product
                            ?.productImage?.[0] ||
                          ""
                        }
                        alt={
                          product?.title ||
                          "New fashion arrival"
                        }
                        sx={{
                          objectFit:
                            "cover",
                          transition:
                            "transform 0.5s ease",
                          "&:hover": {
                            transform:
                              "scale(1.035)",
                          },
                        }}
                      />
                    </Box>

                    <CardContent
                      sx={{
                        px: 0.5,
                        py: 1.5,
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight:
                            600,
                          mb: 0.5,
                        }}
                      >
                        {product?.title ||
                          "Fashion Product"}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight:
                            600,
                          mb: 0.7,
                        }}
                      >
                        ₹
                        {
                          product?.rentAmount
                        }
                        /Day
                      </Typography>

                      {item?.city && (
                        <Box
                          sx={{
                            display:
                              "flex",
                            alignItems:
                              "center",
                            gap: 0.5,
                            mb: 0.5,
                          }}
                        >
                          <LocationOn
                            sx={{
                              fontSize:
                                17,
                              color:
                                "text.secondary",
                            }}
                          />

                          <Typography
                            variant="body2"
                            color="text.secondary"
                          >
                            {item.city}
                          </Typography>
                        </Box>
                      )}

                      {item?.availableDate && (
                        <Typography
                          variant="body2"
                          color="text.secondary"
                        >
                          Available{" "}
                          {
                            item.availableDate
                          }
                        </Typography>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>

          {newArrivals.length ===
            0 && (
              <Box
                sx={{
                  py: 8,
                  textAlign:
                    "center",
                }}
              >
                <Typography color="text.secondary">
                  New arrivals are
                  coming soon.
                </Typography>
              </Box>
            )}
        </Container>
      </Box>

      {/* =====================================================
          FINAL CTA
      ===================================================== */}

      <Box
        sx={{
          py: {
            xs: 8,
            md: 12,
          },
          backgroundColor:
            "#171717",
          color: "#fff",
        }}
      >
        <Container maxWidth="md">
          <Box
            sx={{
              textAlign:
                "center",
            }}
          >
            <Typography
              sx={{
                fontSize:
                  "0.72rem",
                letterSpacing: 3,
                textTransform:
                  "uppercase",
                color:
                  "rgba(255,255,255,0.6)",
                mb: 2,
              }}
            >
              Your next look awaits
            </Typography>

            <Typography
              component="h2"
              sx={{
                fontSize: {
                  xs: "2.4rem",
                  md: "4rem",
                },
                lineHeight: 1.05,
                fontWeight: 500,
                mb: 3,
              }}
            >
              Wear something
              <br />

              <Box
                component="span"
                sx={{
                  fontStyle:
                    "italic",
                  fontWeight: 300,
                }}
              >
                unforgettable.
              </Box>
            </Typography>

            <Typography
              sx={{
                maxWidth: 560,
                mx: "auto",
                color:
                  "rgba(255,255,255,0.68)",
                lineHeight: 1.8,
                mb: 4,
              }}
            >
              Choose your outfit,
              enjoy the moment,
              and return it when
              the occasion is over.
            </Typography>

            <Button
              variant="contained"
              onClick={() =>
                handleExploreClick(
                  "new-arrival"
                )
              }
              sx={{
                px: 4,
                py: 1.5,
                borderRadius: 0,
                backgroundColor:
                  "#fff",
                color: "#111",
                textTransform:
                  "uppercase",
                letterSpacing:
                  1.2,
                fontWeight: 600,
                "&:hover": {
                  backgroundColor:
                    "#eee",
                },
              }}
            >
              Explore Fashion
            </Button>
          </Box>
        </Container>
      </Box>

      {/* =====================================================
          LOGIN POPUP
      ===================================================== */}

      <PopUp
        open={showLoginPopup}
        setOpen={
          setShowLoginPopup
        }
        title="Discover Your Perfect Look"
        description="Sign in to explore premium fashion, save your favorite outfits, and enjoy a seamless rental experience with Hindusthan Wardrobe."
        primaryText="Sign In"
        secondaryText="Continue as Guest"
        onPrimary={
          handleLoginPopupPrimary
        }
      />

      <Footer />
    </Box>
  );
};

export default LandingPage;